import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";

export const useMerchantFacilities = (merchantPublicID?: string) => {
  const { data, isLoading, isError } = useGetMerchantQuery(merchantPublicID);

  return {
    data: data?.facilities || [],
    isLoading,
    isError,
  };
};
